export default function PurchaseSuccessPage() {
    return (
        <main className="flex-1 app-scroll">
            <div className="container-page py-10 sm:py-14">
                <div className="max-w-2xl mx-auto text-center glass p-8 sm:p-10">
                    <div className="w-16 h-16 bg-emerald-500/15 border border-emerald-400/20 rounded-full flex items-center justify-center mx-auto mb-4">
                        <svg className="w-8 h-8 text-emerald-600 dark:text-emerald-300" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                        </svg>
                    </div>
                    <h1 className="text-2xl sm:text-3xl font-bold text-slate-900 dark:text-slate-50 mb-2">Purchase Successful</h1>
                    <p className="text-slate-600 dark:text-slate-300 mb-6">
                        Your credits have been added to your account.
                    </p>
                    <a href="/" className="btn-primary px-6 py-2.5">
                        Start Creating
                    </a>
                </div>
            </div>
        </main>
    );
}
